import { render, staticRenderFns } from "./AbnormalEventTable.vue?vue&type=template&id=5f04fc8a&scoped=true"
import script from "./AbnormalEventTable.vue?vue&type=script&lang=js"
export * from "./AbnormalEventTable.vue?vue&type=script&lang=js"
import style0 from "./AbnormalEventTable.vue?vue&type=style&index=0&id=5f04fc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f04fc8a",
  null
  
)

export default component.exports